import React from "react"
import { gql, useQuery } from "@apollo/client"

const GET_USERS = gql`
  query GetUsers {
    users {
      name
    }
  }
`
export default function LoadUsers() {
  const { loading, error, data } = useQuery(GET_USERS)

  if (loading) return "Loading..."
  if (error) return `Error! ${error.message}`
  return (
    <div>
      Users{" "}
      {data.users.map((user) => (
        <p>{user.name}</p>
      ))}
    </div>
  )
}
